import { SelectChallengeResultTypenames } from '@varo/graphql-schema-types';
import { useLocalSearchParams, useRouter } from 'expo-router';
import useSelectChallengeGql from 'features/otp/hooks/useSelectChallengeGql';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import EmailVerificationScreen from 'shared/components/EmailVerificationScreen/EmailVerificationScreen';
import { useBackHandler } from 'shared/hooks/useBackHandler/useBackHandler';
import { AbortError } from 'shared/hooks/useCancellableMutation';
import { useUserProfile } from 'shared/hooks/useUserProfile';

const VerifyEmailLink = () => {
  const router = useRouter();
  const { t: translatedTextOtp } = useTranslation('otp');
  const { t: translatedTextEmailLinkVerification } = useTranslation('otp', {
    keyPrefix: 'emailLinkVerification',
  });
  const { refetch: refetchUserInfo, customerInfo } = useUserProfile();
  const goBack = () => {
    router.dismissTo({ pathname: '/myvaro/personal-details' });
  };
  const { challengeId } = useLocalSearchParams();
  const { selectChallenge } = useSelectChallengeGql();

  useBackHandler(goBack);

  useEffect(() => {
    void refetchUserInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleResendOtp = async () => {
    try {
      const result = await selectChallenge(challengeId.toString());
      const challengeResult = result.data?.selectChallenge;
      if (
        challengeResult?.__typename ===
        SelectChallengeResultTypenames.SelectChallengeError
      ) {
        return {
          errorCode: Number(challengeResult.code),
          message: challengeResult.message,
          title: challengeResult.title,
        };
      }
      return {};
    } catch (error) {
      if (error instanceof AbortError) {
        return {};
      }
      return {};
    }
  };

  return (
    <EmailVerificationScreen
      titleText={translatedTextEmailLinkVerification('title')}
      headerText={translatedTextEmailLinkVerification('header')}
      description={translatedTextEmailLinkVerification('description', {
        emailId: customerInfo?.email?.address ?? 'your email',
      })}
      openMailButtonLabel={translatedTextEmailLinkVerification(
        'buttons.openEmail',
      )}
      newLinkSentText={translatedTextEmailLinkVerification('newLinkSent')}
      genericErrorText={translatedTextOtp('genericError')}
      onBack={goBack}
      onResendLink={handleResendOtp}
    />
  );
};

export default VerifyEmailLink;
